import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

export class ProtocolTableIdeal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tableData: this.props.tableData
    }
  }

  getContent = (content, headings) => {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "0px"
      }}>
        <div style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: colors.navy1
        }}>
          {headings.map((heading, index) => {
            return (
              <div
                style={{
                  borderTopWidth: 1,
                  borderLeftWidth: 1,
                  borderBottomWidth: "1px",
                  borderColor: colors.navy4,
                  borderStyle: "solid",
                  flexBasis: 1,
                  flexGrow: 1,
                  flexShrink: 1,
                  borderRightWidth: index === headings.length - 1 ? "1px" : 0,
                }}
              >
                <p style={{
                  color: "white",
                  fontSize: "16px",
                  padding: 8,
                  margin: 0,
                  whiteSpace: "pre-wrap"
                }}>{heading}</p>
              </div>
            );
          })}
        </div>
        {content.map((row, rowIndex)=>{
          return(
            <div style={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: (rowIndex === 0)?colors.navy6:null
            }}>
            {row.map((item, itemIndex) => {
              return (
                <div
                  style={{
                    borderBottomWidth: "1px",
                    borderTopWidth: "1px",
                    borderLeftWidth: "1px",
                    borderBottomWidth: "1px",
                    borderColor: colors.navy4,
                    borderStyle: "solid",
                    marginBottom: -1,
                    flexBasis: 1,
                    flexGrow: 1,
                    flexShrink: 1,
                    backgroundColor: itemIndex === 0 ? colors.navy1 : null,
                    borderRightWidth: itemIndex === row.length - 1 ? "1px" : 0
                  }}
                >
                  {(rowIndex === 0 || itemIndex === 0)?(
                    <p style={{
                      color: "black",
                      fontSize: "16px",
                      padding: 8,
                      margin: 0,
                      color: itemIndex === 0 ? "white" : null
                    }}>{item}</p>
                  )
                  :
                  (itemIndex === 1)?(
                    <div className="response">
                      <p>{item}</p>
                    </div>
                  ):(
                    <div className="response">
                      <p>{(item !== null)?item + "μl":null}</p>
                    </div>
                  )
                  }
                </div>
              );
            })}
            </div>
          )
        })}
      </div>
    );
  }

  render() {
    return(
      <div className={this.props.className}>
        <h5 tabIndex={0}>{this.props.heading}</h5>
        {this.getContent(this.state.tableData.data, this.state.tableData.headings)}
      </div>
    )
  }
}
ProtocolTableIdeal.propTypes = {
  type: PropTypes.string,
  tableData: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ProtocolTableIdeal.defaultProps = {
  className: 'ProtocolTableIdeal',
};
